// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("./Photo.jpg", import.meta.url);
// Module
var code = `<figure> <img src="${___HTML_LOADER_IMPORT_0___}" alt=""/><figcaption>The actual connection at Neyland Stadium.</figcaption> </figure> `;
// Exports
export default code;